import React, { useState } from 'react';
import { Card, PillButton, Stack, Text } from 'library/ui';
import { useModalsContext } from 'ModalsContext';
import moment from 'moment';
import { isBefore, isToday } from 'date-fns';
import { useFeatureFlag, FeatureFlag } from 'shared';
import useMicrodepositVerificationInfo from 'parent-portal/home/paymentVerificationWarning/useMicrodepositVerficationInfo';
import MissingMicrodepositVerificationModal from 'parent-portal/home/paymentVerificationWarning/MissingMicrodepositVerificationModal';

import { AutoHireWorkerDialog } from './AutoHireWorker/AutoHireWorkerDialog';
import { useUserContext } from 'UserContext';

export default function PostAShiftCard({
    d,
    addressId,
    businessLocationId,
    timezone,
}: {
    d: Date;
    addressId?: number;
    businessLocationId?: number;
    timezone?: string;
}) {
    const { user } = useUserContext();
    const canPostJobs = user?.address.some((x) => x.can_post_jobs);
    const { openJobForm } = useModalsContext();
    const { featureActive: active } = useFeatureFlag(FeatureFlag.AUTOSCHEDULE_WORKER);
    const [open, setOpen] = useState(false);
    const [missingOpen, setMissingOpen] = useState(false);
    const { blockJobPostingOnVerification } = useMicrodepositVerificationInfo();

    function onAddWorkerClick() {
        blockJobPostingOnVerification ? setMissingOpen(true) : setOpen(true);
    }

    if (isBefore(d, new Date()) && !isToday(d)) {
        return <></>;
    }

    if (!canPostJobs) {
        return <></>;
    }

    return (
        <Card tone="muted" padding="sm">
            <Stack gap="md">
                <Stack gap="sm" align="start">
                    <Text size="sm">Post a shift for {d.toLocaleDateString()}.</Text>
                    <PillButton
                        onClick={() =>
                            openJobForm(`Post a job card (Business Calendar)`, {
                                startDate: moment(d),
                                endDate: moment(d),
                                address: addressId ? [{ id: addressId, businessLocationId, timezone }] : undefined,
                            })
                        }
                    >
                        Post Shift
                    </PillButton>
                </Stack>
                {active && (
                    <Stack gap="sm" align="start">
                        <Text size="xs" weight="bold">
                            OR
                        </Text>
                        <Text size="sm">
                            Automatically add a previous worker to the schedule.
                            <b>
                                <u> They must have already agreed to the shift.</u>
                            </b>
                        </Text>
                        <PillButton onClick={onAddWorkerClick}>Add Worker</PillButton>
                        <AutoHireWorkerDialog open={open} setOpen={setOpen} addressId={addressId} defaultDay={d} />
                    </Stack>
                )}
                <MissingMicrodepositVerificationModal isOpen={missingOpen} onClose={() => setMissingOpen(false)} />
            </Stack>
        </Card>
    );
}
